import { render, staticRenderFns } from "./CustomerIndex.vue?vue&type=template&id=0f3fd564"
import script from "./CustomerIndex.vue?vue&type=script&lang=js"
export * from "./CustomerIndex.vue?vue&type=script&lang=js"
import style0 from "./CustomerIndex.vue?vue&type=style&index=0&id=0f3fd564&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports